import { useCallback } from 'react';

import { FileServiceProviderConfig } from '@work4all/models/lib/Classes/FileServiceProviderConfig.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import { FspStatusCell } from '../FspStatusCell';
import schema from '../schemata/fileServiceProviderConfig-table-schema.json';

import { FspStatusContextProvider } from './FspStatusContext';
import { useDeleteFileServiceProvider } from './use-delete-file-service-provider';
import { useFspCustomActions } from './use-fsp-custom-actions';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

export const FileServiceProviderConfigTable =
  function FileServiceProviderConfigTable(_props) {
    return (
      <FspStatusContextProvider>
        <FileServiceProviderConfigTableInner {..._props} />
      </FspStatusContextProvider>
    );
  };

export const FileServiceProviderConfigTableInner =
  function FileServiceProviderConfigTable(_props) {
    const { entity: entityType } = schema as never;

    const tableProps = {
      schema: schema as never,
      defaultSort,
      cells: {
        FspStatus: FspStatusCell,
      },
    };
    const dataTable = useEntityDataTableV8<FileServiceProviderConfig, never>({
      ...tableProps,
    });

    const [deleteFSP] = useDeleteFileServiceProvider();

    const handleRemove = useCallback(
      async (id: string) => {
        await deleteFSP({
          variables: {
            id: id,
          },
        });
        dataTable.refetch();
      },
      [dataTable, deleteFSP]
    );

    const customActions = useFspCustomActions();

    return (
      <EntityTableV8
        entityType={entityType}
        {...dataTable}
        {..._props}
        actions={{
          createWidget: false,
          remove: {
            handler: (selected) => {
              handleRemove(selected?.[0]);
            },
            maxCount: 1,
          },
          custom: customActions,
        }}
        overrides={{
          areas: {
            left: null,
            right: null,
          },
        }}
      />
    );
  };
